// These options are for the VUE website build

const options = {
  lang: "en",
  buildVersion: "1.0.1",
  routeAdditionalParams: {
    // Hash-mode routes live in #/path — keep base "/" even when assets use /hr/.
    base: "/",
  },
  useDevServer: false,
  devServerUrl: "http://localhost:8000/",
  prodServerUrl: "https://nekohr.nekoapi.xyz/nekoapi/",
  buildType: "WEB",
  commitHash: "2535c2b",
  version: "0.0.4",
};

export default options;
